import 'babel-polyfill'
// import 'es6-promise/auto'

import Vue from "vue";
import VueGtm from 'vue-gtm';
import router from "@/router";
import { modalItems } from "@/router/routes";
import plugins from "@/plugins";
import filters from "@/filters";
import store from "@/store";
import ElementUI from 'element-ui';
import ko from 'element-ui/lib/locale/lang/ko';

import trackingPlugin from '@/plugins/trackingPlugin';
import consultTimePlugin from '@/plugins/consult-time-default';

import App from "@/App";


import "@/stylesheet/_app.scss";
//


import ElementProcessor from "@/components/Elements/Processor";
import ElementProcessorStep from "@/components/Elements/ProcessorStep";
import ElementTextbox from "@/components/Elements/Textbox";
import ElementTextboxHaveCalculate from "@/components/Elements/TextboxHaveCalculate";
import ElementTextarea from "@/components/Elements/Textarea";
import ElementRadio from "@/components/Elements/Radio";
import ElementCarRadio from "@/components/Elements/CarRadio";
import ElementSelect from "@/components/Elements/Select";
import ElementSpreadSelect from "@/components/Elements/SpreadSelect";
import ElementSpreadMultipleSelect from "@/components/Elements/SpreadMultipleSelect";
import ElementCheckbox from "@/components/Elements/Checkbox";
import ElementContentCheckbox from "@/components/Elements/ContentCheckbox";
import ElementContentSpreadCheckbox from "@/components/Elements/ContentSpreadCheckbox";
import ElementRoundButton from "@/components/Elements/RoundButton";
import ElementSendTextModal from "@/components/Elements/SendTextModal";

import ElementCarContentCheckbox from "@/components/Elements/CarContentCheckbox";
import ElementCarPartsList from "@/components/Elements/CarPartsList";
import ElementCarPartsSelect from "@/components/Elements/CarPartsSelect";

import ElementContentRadio from "@/components/Elements/PopupContentRadio";
import ElementTimeSelect from "@/components/Elements/TimeSelect";
import ElementCalendar from "@/components/Elements/Calendar";
import ElementCertification from "@/components/Elements/Certification";
import ElementCheckboxHaveDetail from "@/components/Elements/CheckboxHaveDetail";
import ElementCheckboxHaveDetailSignature from "@/components/Elements/CheckboxHaveDetailSignature";
import ElementTextboxSplited from "@/components/Elements/TextboxSplited";
import ElementTextboxAutoCalculate from "@/components/Elements/TextboxAutoCalculate";
import ElementTextboxHavePrice from "@/components/Elements/TextboxHavePrice";
import ElementSignature from "@/components/Elements/Signature";
import ElementComboBox from "@/components/Elements/ComboBox";

import ElementInsureItem from "@/components/Elements/InsureItem";
import ElementInsureRepairItem from "@/components/Elements/InsureRepairItem";
import ElementTermPopup from "@/components/Elements/TermPopup";
import ElementSignaturePopup from "@/components/Elements/SignaturePopup";

import IncludeEstimateAuth from "@/components/Includes/EstimateAuth";
import IncludeEstimateAuthSelf from "@/components/Includes/EstimateAuthSelf"; //본인확인
import IncludeEstimateComplete from "@/components/Includes/EstimateComplete";
import IncludeEstimateCompleteWithEvent from "@/components/Includes/EstimateCompleteWithEvent";
import IncludeOtherEstimate from "@/components/Includes/OtherEstimate";
import IncludeConsultComplete from "@/components/Includes/ConsultComplete";
import IncludeCarEstimateAuth from "@/components/Includes/CarEstimateAuth";


Vue.component( "ElementProcessor", ElementProcessor );
Vue.component( "ElementProcessorStep", ElementProcessorStep );
Vue.component( "ElementTextbox", ElementTextbox );
Vue.component( "ElementTextboxHaveCalculate", ElementTextboxHaveCalculate );
Vue.component( "ElementTextarea", ElementTextarea );
Vue.component( "ElementRadio", ElementRadio );
Vue.component( "ElementCarRadio", ElementCarRadio );
Vue.component( "ElementCarPartsList", ElementCarPartsList );
Vue.component( "ElementCarPartsSelect", ElementCarPartsSelect );
Vue.component( "ElementSelect", ElementSelect );
Vue.component( "ElementSpreadSelect", ElementSpreadSelect );
Vue.component( "ElementSpreadMultipleSelect", ElementSpreadMultipleSelect );
Vue.component( "ElementCheckbox", ElementCheckbox );
Vue.component( "ElementContentCheckbox", ElementContentCheckbox );
Vue.component( "ElementContentSpreadCheckbox", ElementContentSpreadCheckbox );
Vue.component( "ElementComboBox", ElementComboBox );
Vue.component( "ElementRoundButton", ElementRoundButton );
Vue.component( "ElementContentRadio", ElementContentRadio );
Vue.component( "ElementCalendar", ElementCalendar );
Vue.component( "ElementTimeSelect", ElementTimeSelect );
Vue.component( "ElementCarContentCheckbox", ElementCarContentCheckbox );
Vue.component( "ElementCertification", ElementCertification );
Vue.component( "ElementTextboxSplited", ElementTextboxSplited );
Vue.component( "ElementTextboxAutoCalculate", ElementTextboxAutoCalculate );
Vue.component( "ElementCheckboxHaveDetail", ElementCheckboxHaveDetail );
Vue.component( "ElementInsureItem", ElementInsureItem );
Vue.component( "ElementInsureRepairItem", ElementInsureRepairItem );
Vue.component( "ElementTermPopup", ElementTermPopup );
Vue.component( "ElementTextboxHavePrice", ElementTextboxHavePrice );
Vue.component( "ElementSendTextModal", ElementSendTextModal );
Vue.component( "ElementSignature", ElementSignature );
Vue.component( "ElementSignaturePopup", ElementSignaturePopup );
Vue.component( "ElementCheckboxHaveDetailSignature", ElementCheckboxHaveDetailSignature );


Vue.component( "IncludeEstimateComplete", IncludeEstimateComplete );
Vue.component( "IncludeEstimateCompleteWithEvent", IncludeEstimateCompleteWithEvent );
Vue.component( "IncludeOtherEstimate", IncludeOtherEstimate );
Vue.component( "IncludeEstimateAuth", IncludeEstimateAuth );
Vue.component( "IncludeEstimateAuthSelf", IncludeEstimateAuthSelf );
Vue.component( "IncludeConsultComplete", IncludeConsultComplete );
Vue.component( "IncludeCarEstimateAuth", IncludeCarEstimateAuth );


import ElementTab from "@/components/Elements/Tab";
import ElementTabItem from "@/components/Elements/TabItem";
import ElementModal from "@/components/Elements/Modal";
import ElementConfirm from "@/components/Elements/Confirm";
import ElementSnackbar from "@/components/Elements/Snackbar";
import ElementSearch from "@/components/Elements/Search"
import ElementAutocomplete from "@/components/Elements/Autocomplete";
import ElementBoard from "@/components/Elements/Board"
import ElementBoardItem from "@/components/Elements/BoardItem"
import ElementPopup from "@/components/Elements/Popup"
import ElementSearchPopup from "@/components/Elements/SearchPopup"
import ElementPopupSearchPet from "@/components/Elements/PopupSearchPet"
Vue.component( "ElementTab", ElementTab );
Vue.component( "ElementTabItem", ElementTabItem );
Vue.component( "ElementModal", ElementModal );
Vue.component( "ElementConfirm", ElementConfirm );
Vue.component( "ElementSnackbar", ElementSnackbar );
Vue.component( "ElementSearch", ElementSearch );
Vue.component( "ElementAutocomplete", ElementAutocomplete );
Vue.component( "ElementBoard", ElementBoard );
Vue.component( "ElementBoardItem", ElementBoardItem );
Vue.component( "ElementPopup", ElementPopup );
Vue.component( "ElementSearchPopup", ElementSearchPopup );
Vue.component( "ElementPopupSearchPet", ElementPopupSearchPet );

import vueSmoothScroll from 'vue2-smooth-scroll' //'vue-smooth-scroll'
Vue.use(vueSmoothScroll)

import { PaginationPlugin } from 'bootstrap-vue'
Vue.use( PaginationPlugin );

import WCSPlugin from '@/plugins/WCSPlugin.js';

Vue.use(WCSPlugin)

import VueProgressBar from 'vue-progressbar'
Vue.use(VueProgressBar, {
  color: 'rgb(92, 135, 255)',
  failedColor: '#f16969',
  thickness: '2px'
})

Vue.use(trackingPlugin);
Vue.use(consultTimePlugin);

// 다음 주소 검색 api
import VueDaumPostcode from 'vue-daum-postcode'
Vue.use(VueDaumPostcode)

Vue.use(ElementUI, { locale: ko });

router.beforeEach( ( to, from, next ) => {
  let { name, isProcessor } = to.meta;
  Vue.prototype.$Progress.start()
  /*if(to.meta.name == '상담예약' && to.redirectedFrom && from.path == "/" && from.meta.name != '상담예약' ){
    store.commit( "SET_IS_PROCESSOR", true );
  }else if(to.meta.name == '상담예약' && !to.redirectedFrom && from.path != "/" && from.meta.name != '상담예약' ){
    store.commit( "SET_IS_PROCESSOR", false );
  }else if(to.meta.name != '상담예약' && from.meta.name != '상담예약' ){
    store.commit( "SET_IS_PROCESSOR", modalItems[ to.name ] ? true : false );
  }*/
  store.commit("SET_PREV_PATH", { path: from.path });

  if( modalItems[ to.name ] && !store.state.config.isTouchDevice){
    var tmp = { ...from };
    if(to.query) Object.assign(tmp.query, to.query)
    store.commit( "SET_IS_PROCESSOR", modalItems[ to.name ] ? true : false );
    setTimeout(() => {
      store.commit( "elementModal/SET_ITEM", { elementId: "global"+to.name });
    });
    next( from ?  { ...from } : { name: "Home" });
  }else if (to.path == '/reservation' && !store.state.config.isTouchDevice) {
    // PC URL 접근
    store.commit( "SET_IS_PROCESSOR", true );
    setTimeout(() => {
      store.commit( "elementModal/SET_ITEM", { elementId: "globalEstimateConsultation" });
    });
    next();
  }else if ( from.name == null && from.path == "/" && !store.state.config.isTouchDevice && to.query.procstep && (to.name == 'CompareEstimate' || to.name == 'Guarantee' || to.name == 'Gift')) {
    var to_name = "";
    switch (to.query.tab) {
      case "자동차보험":
        to_name = "CarInsurance"
        break;
      case "운전자보험":
        to_name = "DriverInsurance";
        break;
      case "실손의료보험":
        to_name = "EstimateLosslessMedicalInsurance";
        break;
      case "암/2대질병 보험":
        to_name = "CancerInsurance";
        break;
      case "어린이보험":
        to_name = "ChildInsurance";
        break;
      case "태아보험":
        to_name = "FetalInsurance";
        break;
      case "정기보험":
        to_name = "TermInsurance";
        break;
      case "종신보험":
        to_name = "WholeLifeInsurance";
        break;
      case "화재보험":
        to_name = "FireInsurance";
        break;
      case "연금보험":
        to_name = "PensionInsurance";
        break;
      case "치아보험":
        to_name = "DentalInsurance";
        break;
      case "치매보험":
        to_name = "DementiaInsurance";
        break;
      case "펫보험":
        to_name = "PetInsurance";
        break;
    }
    if(to.query.procstep == "전화상담") {
      to_name = "Consultation"
    }else if(to.query.procstep == "서비스 신청하기") {
      to_name = "Service"
    }
    store.commit( "SET_IS_PROCESSOR", true);
    setTimeout(() => {
      store.commit( "elementModal/SET_ITEM", { elementId: "global" + to_name });
    });
    next();
  }else{

    setTimeout(() => {
      store.commit( "SET_PAGENAME", { name });
    });
    if (to.path == '/reservation' && store.state.config.isTouchDevice) {
      /*var tmp = { ...from };

      if(to.query) Object.assign(tmp.query, to.query)*/
      next({name : "EstimateConsultation", query: to.query});
    }else{
      if(from.name != "EstimateConsultation" || to.name != "EstimateConsultation"){
        if(to.name == "EstimateConsultation" && from.path == "/"){
          store.commit( "SET_IS_PROCESSOR", true );
        }else if(to.name == "EstimateConsultation" && from.path != "/"){
          store.commit( "SET_IS_PROCESSOR", false );
        } else {
          store.commit( "SET_IS_PROCESSOR", modalItems[ to.name ] ? true : false );
        }
      }else{
      }
      
      next();
    }
    
  };
});


router.afterEach( (to, from) => {
  Vue.myGlobalMethod();
  gtag('config', 'UA-149825488-1', {'page_path': to.fullPath});
  _trs_analysis();
  Vue.prototype.$Progress.finish();
});

Vue.use(VueGtm, {
  id: 'GTM-TCX9M8T', // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
  defer: false, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional) 
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
});

store.dispatch( "customer/refresh" ).finally( () => {
  /*new Vue({
    el: "#app",
    components: {
      App,
    },
    template: "<App/>",
    router,
    store,
    render: function (h) { return h(App) }
  });*/

  new Vue({
    router,
    store,
    render: function (h) { return h(App) }
  }).$mount('#app')
})
